import React, { Component } from 'react';
export default class Resume extends Component {
  render() {
    return (
        <section id="resume">
        <div className="row work">
          <div className="three columns header-col">
            <h1><span>Work</span></h1>
          </div>
          <div className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">
                <h3>Harbor Capital Advisors</h3>
                <p className="info">Full Stack Engineer III <span>•</span> <em className="date">May 2024 - March 2026</em></p>
                <p>
                Promoted to Full Stack Engineer III in February 2026. Led AI Engineering team to experiment, research, build, and deploy
                applications that utilize AI to automate tasks for business users. Architected and implemented a centralized identity provider,
                securing internal APIs and external applications. Modernized majority of applications to utilize monorepo and consistent
                deployment framework. Mentored and developed junior engineers. Reviewed architecture and code across engineering projects
                to ensure quality and consistency.
                </p>
              </div>
              <div className="twelve columns">
                <h3>Discover Financial Services</h3>
                <p className="info">Lead Software Engineer <span>•</span> <em className="date">February 2023 - May 2024</em></p>
                <p>
                Led development of a model inventory replacement tool using Node.js and React. Implemented full-stack features in an
                AI Model Training application (Spring Boot, Angular). Unblocked and improved performance of banking teams' Python AI models.
                Monitored and troubleshot issues on OpenShift related to application and image deployment. Updated tooling container images
                to add functionality, fix bugs, and mitigate security concerns.
                </p>
              </div>
              <div className="twelve columns">
                <h3>Topology Eyewear</h3>
                <p className="info">Senior Software Engineer <span>•</span> <em className="date">August 2020 - January 2023</em></p>
                <p>
                Extracted, structured, and analyzed Segment app usage data from Redshift using Pandas and NumPy. Built a rendering server
                with FastAPI and an internal rendering engine to assist with frame digitization. Created a material search tool using Bokeh
                and ML algorithms to find materials based on similarity. Architected solutions to scale digitization tools to utilize cloud
                resources. Created reporting automation using Python, Lambda, CloudWatch, and MongoDB.
                </p>
              </div>
              <div className="twelve columns">
                <h3>Discover Financial Services</h3>
                <p className="info">Data Platform Engineer <span>•</span> <em className="date">July 2017 - August 2020</em></p>
                <p>
                Built and deployed Universal Access Layer using AWS services, Python, and Terraform. Built CI/CD for Universal Access Layer
                including Jenkins pipeline to deploy and run tests. Installed and tested distributed computing tools for analytics including
                EMR, Spark, and Kafka. Trained new associates in AWS architecting, Terraform, and orchestrating deployment. Assisted with
                migration of analytical environment from on-prem Hadoop to AWS.
                </p>
              </div>
              <div className="twelve columns">
                <h3>Loyola University Chicago Information Security Office</h3>
                <p className="info">Information Security Intern <span>•</span> <em className="date">August 2016 - March 2017</em></p>
              </div>
            </div>
          </div>
        </div>
        <div className="row work">
          <div className="three columns header-col">
            <h1><span>Projects</span></h1>
          </div>
          <div className="nine columns main-col">
            <div className="row item">
            <div className="twelve columns">
                <h3>Harbor Capital Identity Provider</h3>
                <p className="info">Lead Engineer <span>•</span> <em className="date">2024 - 2026</em></p>
                <p>
                A Cognito-based identity provider supporting external users, internal applications, and machine-to-machine authentication
                for internal APIs. Implemented complex access logic based on institutional investor status, with group-role mapping and
                fine-grained permissions stored in DynamoDB and encoded in JWTs to streamline authorization and enable scalable policy enforcement.
                </p>
              </div>
            <div className="twelve columns">
                <h3>Asset Workflow Tool Suite (Topology Eyewear)</h3>
                <p className="info">Lead Engineer <span>•</span> <em className="date">May 2021 - December 2022</em></p>
                <p>
                Tools used to digitize eyewear assets for use in virtual try-on application. The tools allow for assets
                to move through a pipeline of several steps, providing automated checks, metrics, and reviewing capabilities
                for various stakeholders to approve or request changes along the way.
                </p>
              </div>
              <div className="twelve columns">
                <h3>Universal Access Layer (Discover Financial Services)</h3>
                <p className="info">Lead Engineer <span>•</span> <em className="date">March 2018 - May 2020</em></p>
                <p>
                A serverless AWS architecture designed to integrate with Discover's directory services to dynamically provide
                fine-grained, federated access to the S3 data lake. AWS Services Used: DynamoDB, SQS, IAM, SNS, API Gateway,
                Secrets Manager, Lambda, CloudWatch. Built on the AWS console, written in Terraform, and deployed across multiple
                AWS accounts through Jenkins with one-touch deployments and automated unit tests.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row work">
          <div className="three columns header-col">
            <h1><span>Certifications</span></h1>
          </div>
          <div className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">
                <h3>AWS Certified Solutions Architect - Associate</h3>
                <p className="info"><em className="date">Issued 2018</em></p>
              </div>
            </div>
          </div>
        </div>
        <div className="row education">
          <div className="three columns header-col">
            <h1><span>Education</span></h1>
          </div>
          <div className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">
                <h3>Loyola University Chicago</h3>
                <p className="info">B.B.A. in Information Systems, Minor in Computer Science <span>•</span> <em className="date">May 2017, Cum Laude</em></p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
